import type { ApolloClient } from '@apollo/client';
import {
  GET_GATE_RENDERER_DATA,
  GET_GATE_RENDERER_DATA_FOR_METRICS_VIEW,
} from '../graphql/queries/getGateRendererData';
import { GET_MOVEMENT_DATA } from '../graphql/queries/getMovementRendererData';

export const refreshActiveGateData = async <TCacheShape extends object>(
  client: ApolloClient<TCacheShape>,
) => {
  try {
    await client.refetchQueries({
      include: [GET_GATE_RENDERER_DATA, GET_GATE_RENDERER_DATA_FOR_METRICS_VIEW, GET_MOVEMENT_DATA],
    });
  } catch (error) {
    console.error(
      '[GateMessagesSubscription] no se pudieron refrescar los datos al recuperar foco',
      error,
    );
  }
};

export const refreshActiveGateDataWhenVisible = <TCacheShape extends object>(
  client: ApolloClient<TCacheShape>,
  visibilityState: DocumentVisibilityState,
) => (visibilityState === 'visible' ? refreshActiveGateData(client) : Promise.resolve());
